export const PAYMENT_METHODS = [
  { id: "MTN", label: "MTN" },
  { id: "AIRTEL", label: "Airtel" },
];

const RW_PHONE_RE = /^(\+250|250|0)?[0-9]{9}$/;

export const isValidRwandanPhone = (phone) =>
  RW_PHONE_RE.test(String(phone || "").replace(/\s/g, ""));

export const normalizePhoneInput = (phone) => {
  const raw = String(phone || "").trim();
  if (!raw) return "";
  if (raw.startsWith("+")) {
    return `+${raw.slice(1).replace(/\D/g, "")}`;
  }
  return raw.replace(/\D/g, "");
};

export const resolvePaymentUserId = (userId) => {
  if (userId == null || userId === "") return "";
  if (typeof userId === "object" && userId._id != null) {
    return String(userId._id);
  }
  return String(userId);
};

export const parsePaymentAmount = (value) => {
  const num = Number(value);
  if (!Number.isFinite(num) || num <= 0) return null;
  return num;
};

export const getApiErrorMessage = (error, fallback = "Something went wrong") =>
  error?.response?.data?.message ||
  error?.response?.data?.error ||
  error?.message ||
  fallback;

export const stripPaymentProviderBranding = (text) => {
  if (text == null || text === "") return text;

  let cleaned = String(text)
    .replace(/(?:in\s*touch|paypack)\s*pay(?:ments?)?\s*/gi, "")
    .replace(/\s{2,}/g, " ")
    .trim();

  if (cleaned && /^[a-z]/.test(cleaned)) {
    cleaned = cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
  }

  return cleaned;
};

export const formatTransactionDescription = (description) =>
  description ? stripPaymentProviderBranding(description) : description;

export const PENDING_DEPOSIT_APPROVAL_NOTE =
  "Approve this payment on your phone, or dial *182*7*1# to confirm. If it is not approved soon, it will be canceled.";

export const shouldShowPendingDepositApprovalNote = (transaction) => {
  const status = String(transaction?.status || "").toLowerCase();
  return (
    transaction?.transactionType === "Deposit" &&
    transaction?.method === "MobileMoney" &&
    status === "pending"
  );
};

export const getPaymentProviderMessage = (data) =>
  stripPaymentProviderBranding(
    data?.providerResponse?.statusdesc ||
      data?.providerResponse?.message ||
      data?.message ||
      ""
  );

export {
  isPaymentDepositSuccess,
  isPaymentWithdrawalSuccess,
} from "./intouchPayResponseCodes";

export const isPhoneOnlyAccount = (user) =>
  Boolean(user?.phoneNumber && !user?.email);

export const getAccountPhoneInputValue = (phone) => {
  if (!phone) return "";
  const digits = String(phone).replace(/\D/g, "");
  if (digits.startsWith("250") && digits.length === 12) {
    return `0${digits.slice(3)}`;
  }
  if (digits.startsWith("0")) return digits;
  if (digits.length === 9) return `0${digits}`;
  return String(phone);
};
